export const sxStyle = {
  title: {
    color: 'black',
    fontWeight: 600,
    fontSize: { xs: 14, sm: 16 },
  },

  subTitle: {
    color: 'black',
    fontSize: { xs: 12, sm: 14 },
  },

  divider: {
    my: { xs: '10px', sm: '20px' },
    color: '#000',
  },

  seeRefundability: {
    fontSize: '16px',
    color: '#03C868',
    fontWeight: 600,
    textAlign: 'center',
  },

  seeSubRefundability: {
    fontSize: '16px',
    color: '#000000',
    textAlign: 'center',
  },

  seeNoRefundability: {
    fontSize: '16px',
    fontWeight: 600,
    textAlign: 'center',
    color: 'red',
  },

  seeSubNoRefundability: {
    fontSize: '16px',
    textAlign: 'center',
    color: 'red',
  },

  seeToRefundability: {
    fontSize: '16px',
    color: '#000000',
    textAlign: 'center',
  },

  rooms: {
    fontSize: '16px',
    color: '#000',
  },

  cancellTextButton: {
    background: 'none',
    boxShadow: 'none',
    p: 0,
    minWidth: 0,
    textTransform: 'none',
    fontSize: 16,
    '&:hover': {
      background: 'none',
      textDecoration: 'underline',
    },
  },
};
